export function tagActivo (estado) {
  let estados = {
    A: {
      class: 'is-success',
      text: 'Activo'
    },
    D: {
      class: 'is-danger',
      text: 'Desactivado'
    },
    E: {
      class: 'is-dark',
      text: 'Eliminado'
    }
  }
  if (estados[estado] !== undefined) {
    return `<span class="tag ${estados[estado].class}"><span>${estados[estado].text}</span></span>`
  } else {
    return `<span class="tag"><span>DEFINIR</span></span>`
  }
}

export function buttonsAcciones (data) {
return (d, t, r) => `
  <div class="buttons is-center">
      <a href="${data.translateUrl + d}" data-id="${d}" data-accion="translate" class="button is-small is-info btn-acciones" title="Traducir">
          <span class="icon is-small"><i class="fas fa-globe"></i></span>
      </a>
      <a href="${data.baseurl + d}" data-id="${d}" data-accion="ver" class="button is-small is-info btn-acciones" title="Ver">
          <span class="icon is-small"><i class="fas fa-eye"></i></span>
      </a>
      <a href="${data.baseurl + d + '/edit'}" data-id="${d}" data-accion="editar" class="button is-small is-info btn-acciones" title="Editar">
          <span class="icon is-small"><i class="fas fa-pen"></i></span>
      </a>
      <button type="button" data-id="${d}" data-accion="estado" class="button is-small is-info btn-acciones" title="Estado">
          <span class="icon is-small"><i class="fas fa-sync"></i></span>
      </button>
      <button type="button" data-id="${d}" data-accion="eliminar" class="button is-small is-info btn-acciones" title="Eliminar">
          <span class="icon is-small"><i class="fas fa-trash"></i></span>
      </button>
  </div>
`
}


export function PageLength () {

  return `${process.env.REACT_APP_PAGE_LENGTH?process.env.REACT_APP_PAGE_LENGTH:10}`
}